var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833496 2.50041C0.833409 2.20716 0.910701 1.91907 1.05757 1.66524C1.20443 1.41141 1.41567 1.20082 1.66996 1.05474C1.92424 0.908664 2.21257 0.832266 2.50582 0.833262C2.79908 0.834257 3.08688 0.912611 3.34016 1.06041L13.3377 6.89208C13.59 7.03848 13.7994 7.24853 13.9451 7.50125C14.0908 7.75397 14.1676 8.04049 14.1679 8.33219C14.1681 8.6239 14.0918 8.91055 13.9466 9.16352C13.8013 9.41649 13.5922 9.62691 13.3402 9.77375L3.34016 15.6071C3.08688 15.7549 2.79908 15.8332 2.50582 15.8342C2.21257 15.8352 1.92424 15.7588 1.66996 15.6127C1.41567 15.4667 1.20443 15.2561 1.05757 15.0023C0.910701 14.7484 0.833409 14.4603 0.833496 14.1671V2.50041Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.47a0e844a4ec0b344ddf607d2e2cd2dc.svg";
export { ForwardRef as ReactComponent };